import { type Html, html, View, UnsafeHtml, rune } from 'rune-ts';
import klass from './AdSection.module.scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { font } from '../../../../../shared/typography';
import { TriangleDownIcon } from '../../../../../shared/components/atoms/Icon/foundation_icons';
import { htmlIf } from '../../../../../shared/util';
import { media_url_info } from '../../constant';

export class AdSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      speech_bubble_1: html.preventEscape(`브랜드와 어떻게 컨택해야 할지<br/>모르겠어요`),
      speech_bubble_2: is_mobile
        ? html.preventEscape(`브랜드와 직접 협상하는 게<br/> 너무 어려워요`)
        : '브랜드와 직접 협상하는 게 너무 어려워요',
      speech_bubble_3: html.preventEscape(`계약? 정산?<br/>절차가 복잡하고 부담스러워요`),
      title: is_mobile
        ? html.preventEscape(`마플샵이 모두 <br/> 해결해 드릴게요!`)
        : '마플샵이 모두 해결해 드릴게요!',
      desc: is_mobile
        ? html.preventEscape(
            `내 채널에 딱 맞는 브랜드 매칭부터 <br/>
            협상, 계약, CS, 정산까지 <br/>
            크리에이터님은 SNS 홍보만 하세요 <br/>
            나머지는 마플샵이 케어해 드립니다`,
          )
        : html.preventEscape(
            `내 채널에 딱 맞는 브랜드 매칭부터 협상, 계약, CS, 정산까지<br>크리에이터님은 SNS 홍보만 하세요<br>나머지는 마플샵이 케어해 드립니다`,
          ),
    };
    return html`
      <section class="${klass.ad}">
        <div class="${klass.image_list}">
          ${htmlIf(
            this.drawImage({
              url: media_url_info.ad_section.image_1,
            }),
            !is_mobile,
          )}
          ${this.drawVideo({
            url: media_url_info.ad_section.video_1,
            speech_bubble_top: is_mobile ? '-5' : '105',
            speech_bubble_left: is_mobile ? '40' : '0',
            speech: texts.speech_bubble_1,
            tail_position: is_mobile ? klass.top_left : klass.bottom_left,
          })}
          ${this.drawVideo({
            url: media_url_info.ad_section.video_2,
            speech_bubble_top: is_mobile ? '85' : '-20',
            speech_bubble_left: is_mobile ? '25' : '50',
            speech: texts.speech_bubble_2,
            tail_position: is_mobile ? '' : klass.top,
          })}
          ${this.drawVideo({
            url: media_url_info.ad_section.video_3,
            speech_bubble_top: is_mobile ? '100' : '-5',
            speech_bubble_left: is_mobile ? '70' : '75',
            speech: texts.speech_bubble_3,
            tail_position: is_mobile ? klass.bottom_right : klass.top_right,
          })}
          ${htmlIf(
            this.drawImage({
              url: media_url_info.ad_section.image_2,
            }),
            !is_mobile,
          )}
        </div>
        <div class="${klass.content}">
          <div class="${font('48_bold', '28_bold')}">${texts.title}</div>
          <div class="${font('28_medium', '16_medium')}">${texts.desc}</div>
        </div>
      </section>
    `;
  }

  drawImage = ({ url }: { url: string }) => {
    return html`
      <div class="${klass.image_item}">
        <div class="${klass.image_wrapper}">
          <img
            src="${getResizedUrl({
              url,
              width: 400 * 2,
              quality: 85,
              format: 'webp',
            })}"
            alt="혜택 1"
          />
        </div>
      </div>
    `;
  };

  drawVideo = ({
    url,
    speech_bubble_top,
    speech_bubble_left,
    speech,
    tail_position,
  }: {
    url: string;
    speech_bubble_top: string;
    speech_bubble_left: string;
    speech: string | UnsafeHtml;
    tail_position: string;
  }) => {
    return html`
      <div class="${klass.image_item}">
        <div class="${klass.image_wrapper}">
          <video autoplay="" loop="" muted="" playsinline="" src=${url}></video>
        </div>
        <div
          class="${klass.speech_bubble_wrapper} ${font('24_bold', '16_medium')}"
          style="top: ${speech_bubble_top}%; left: ${speech_bubble_left}%"
        >
          <div class="${klass.speech_bubble}">
            <div>${speech}</div>
            ${TriangleDownIcon({ klass: `${klass.bubble_tail} ${tail_position}` })}
          </div>
        </div>
      </div>
    `;
  };
}
